import { render, staticRenderFns } from "./metalPricingDtlRpt.vue?vue&type=template&id=952b4556&scoped=true&"
import script from "./metalPricingDtlRpt.vue?vue&type=script&lang=js&"
export * from "./metalPricingDtlRpt.vue?vue&type=script&lang=js&"
import style0 from "./metalPricingDtlRpt.vue?vue&type=style&index=0&id=952b4556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952b4556",
  null
  
)

export default component.exports